import { CompanyDailyNavConfigVersion } from 'api';
import {
  DAILY_NAV_THRESHOLD_KEYS,
  DailyNavThresholdKey,
  fractionToPercent,
  isValidThresholdPercent,
  percentToFraction,
} from 'common/constants/dailyNav';

// Overrides are kept as strings: '' means "inherited from the firm default",
// while any other value — including '0' — is an explicit override.
export type ThresholdOverrides = Record<DailyNavThresholdKey, string>;

// Null from the API means "inherited"; 0 is a valid explicit override.
export const overridesFromConfig = (config?: CompanyDailyNavConfigVersion | null): ThresholdOverrides =>
  Object.fromEntries(DAILY_NAV_THRESHOLD_KEYS.map(key => [key, fractionToPercent(config?.[key])])) as ThresholdOverrides;

export const overridesToPayload = (overrides: ThresholdOverrides) =>
  Object.fromEntries(
    DAILY_NAV_THRESHOLD_KEYS.map(key => [key, overrides[key] === '' ? null : percentToFraction(overrides[key])])
  ) as Record<DailyNavThresholdKey, string | null>;

export const areOverridesValid = (overrides: ThresholdOverrides) =>
  DAILY_NAV_THRESHOLD_KEYS.every(key => overrides[key] === '' || isValidThresholdPercent(overrides[key]));

export const overridesDiffer = (config: CompanyDailyNavConfigVersion | null | undefined, overrides: ThresholdOverrides) =>
  DAILY_NAV_THRESHOLD_KEYS.some(key => fractionToPercent(config?.[key]) !== overrides[key]);
